import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import bus from "../common/bus";
import { get, post } from '@/api/fetch.js';
import url from '@/api/serviceAPI.config.js';
import password from '@/components/common/password';
export default {
  data: function data() {
    return {
      collapse: false,
      fullscreen: false,
      name: 'admin',
      message: null,
      showReset: false,
      formLabelWidth: '80px',
      passwordForm: {
        oldPassword: null,
        password: null,
        passwordConfirm: null
      },
      addLoading: false,
      passwordRules: {
        oldPassword: [{
          required: true,
          message: '请输入原密码',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }],
        passwordConfirm: [{
          required: true,
          message: '请确认密码',
          trigger: 'blur'
        }]
      }
    };
  },
  components: {
    password: password
  },
  computed: {
    username: function username() {
      var username = localStorage.getItem('account');
      return username ? username : this.name;
    }
  },
  methods: {
    // 侧边栏折叠
    collapseChage: function collapseChage() {
      this.collapse = !this.collapse;
      bus.$emit('collapse', this.collapse);
    },
    // 退出登录
    logout: function logout() {
      var _this = this;
      get(url.log.logout).then(function (res) {
        localStorage.removeItem('userName');
        localStorage.removeItem('userId');
        _this.$router.push('/login');
      }).catch(function (err) {
        console.log(err);
      });
    },
    //显示修改密码弹出框
    modifyPassword: function modifyPassword(command) {
      if (command == 'password') {
        this.showReset = true;
      }
    },
    //隐藏弹出框
    addRoleDialogHide: function addRoleDialogHide() {
      this.showReset = false;
    }
  },
  mounted: function mounted() {
    if (document.body.clientWidth < 1500) {
      this.collapseChage();
    }
  }
};